// @ts-nocheck
/** Koleksiyon vitrini — Swiper açıksa 749px altı; root’ta data-collection-list-root olmalı. */

(function () {
  function num(v, fallback) {
    const x = parseFloat(String(v), 10);
    return Number.isFinite(x) ? x : fallback;
  }

  function mobileMq() {
    return window.matchMedia("(max-width: 749px)");
  }

  function desktopMq() {
    return window.matchMedia("(min-width: 990px)");
  }

  function activeMode(root) {
    if (!root) return null;

    const mobileSetting = root.dataset.swiperMobile;

    const mobileEnabled =
      mobileSetting === undefined || mobileSetting === "true";

    if (mobileMq().matches && mobileEnabled) {
      return "mobile";
    }

    if (
      desktopMq().matches &&
      root.dataset.swiperDesktop === "true"
    ) {
      return "desktop";
    }

    return null;
  }

  function destroy(root) {
    if (!root || !root._collectionListSwiper) return;
    try {
      root._collectionListSwiper.destroy(true, true);
    } catch {
      /* ignore */
    }
    root._collectionListSwiper = null;
  }

  function collectRoots(target) {
    if (!target || !target.querySelectorAll) {
      return Array.from(document.querySelectorAll("[data-collection-list-root]"));
    }
    const list = Array.from(target.querySelectorAll("[data-collection-list-root]"));
    if (target.matches && target.matches("[data-collection-list-root]")) {
      list.unshift(target);
    }
    return list.length ? list : Array.from(document.querySelectorAll("[data-collection-list-root]"));
  }

  function init(root, swiperRetry) {
    if (!root || root.isConnected === false) return;

    const mode = activeMode(root);
    if (!mode) return;

    const isDesktop = mode === "desktop";

    const el = root.querySelector(".section-collection-list__swiper--mobile");
    if (!el) return;

    if (typeof Swiper === "undefined") {
      const next = (swiperRetry || 0) + 1;
      if (next < 40) {
        setTimeout(() => init(root, next), 50);
      }
      return;
    }

    const slides = el.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    destroy(root);

    const gap = num(
      isDesktop
        ? root.dataset.desktopSpaceBetween
        : root.dataset.spaceBetween,
      16
    );

    const slidesPerView = num(
      isDesktop
        ? root.dataset.slidesDesktop
        : root.dataset.slidesSm,
      isDesktop ? 2.5 : 1
    );

    const autoplayOn = isDesktop
      ? root.dataset.desktopAutoplay === "true"
      : root.dataset.autoplay === "true";

    const autoplayMs = num(
      isDesktop
        ? root.dataset.desktopAutoplayMs
        : root.dataset.autoplayMs,
      4000
    );

    const rewindOn = isDesktop
      ? root.dataset.desktopRewind === "true"
      : root.dataset.rewind === "true";

    const prevEl = root.querySelector(
      isDesktop
        ? "[data-cl-prev-desktop]"
        : "[data-cl-prev]"
    );

    const nextEl = root.querySelector(
      isDesktop
        ? "[data-cl-next-desktop]"
        : "[data-cl-next]"
    );

    const hasNav = Boolean(
      prevEl &&
      nextEl &&
      slides.length > 1
    );

    root._collectionListSwiper = new Swiper(el, {
      slidesPerView: slidesPerView,
      spaceBetween: gap,
      watchSlidesProgress: true,
      watchOverflow: true,
      grabCursor: true,
      speed: 500,
      rewind: rewindOn,
      navigation: hasNav ? { prevEl, nextEl } : undefined,
      autoplay: autoplayOn
        ? { delay: autoplayMs, disableOnInteraction: true, pauseOnMouseEnter: true }
        : false,
    });
  }

  function sweepRoots(roots) {
    roots.forEach((root) => {
      destroy(root);

      if (activeMode(root)) {
        init(root, 0);
      }
    });
  }

  function refresh(event) {
    const roots = collectRoots(event && event.target);
    requestAnimationFrame(() => sweepRoots(roots));
  }

  function boot() {
    sweepRoots(collectRoots(null));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  const mobileMediaQuery = mobileMq();
  const desktopMediaQuery = desktopMq();

  const onMqChange = () => {
    sweepRoots(collectRoots(null));
  };

  [mobileMediaQuery, desktopMediaQuery].forEach((mediaQuery) => {
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", onMqChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(onMqChange);
    }
  });

  ["shopify:section:load", "shopify:section:reorder", "shopify:section:select", "shopify:block:select"].forEach((name) => {
    document.addEventListener(name, refresh);
  });
})();
